import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import { Keys } from '~commonInfra/utils/Keys';

/**
 * This is deprecated because, even though it's written in React, it doesn't use Shared Widgets.
 */
export class DeprecatedReactMenu extends React.Component<DeprecatedReactMenu.Props, DeprecatedReactMenu.State> {

  static displayName = 'Menu';

  private static nextId = 1;

 // TODO createFactory is deprecated, refactor all callers to do React.createElement(Menu, props) instead
  public static element = React.createFactory(DeprecatedReactMenu);

  private id: string;

  state: DeprecatedReactMenu.State = {
    open: false,
    hovered: false
  };

  public componentDidMount() {
    this.id = ''+DeprecatedReactMenu.nextId++;
    this.closeMenuOnMouseDownOutside();
  }

  private closeMenuOnMouseDownOutside() {
    const element = $(ReactDOM.findDOMNode(this) as HTMLElement);

    const eventNamespace = this.getEventNamespace();
    const mouseDownEvents = 'mousedown' + eventNamespace + ' touchstart' + eventNamespace;

    // $todo: use react event system or at least something that plays nice with react
    $(document).on(mouseDownEvents, (downEvent: JQuery.TriggeredEvent) => {
      const target = $(downEvent.target);

      // Also check the panel which could have set a menuPanelDivId using an overlay so it won't be a child of the button
      if (target.closest(element).length === 0 && target.closest($('#' + this.props.menuPanelDivId)).length === 0) {
        if (this.state.open) {
          this.closeMenu();
        }
      }
    });
  }

  public componentWillUnmount() {
    $(document).off(this.getEventNamespace());
  }

  private getEventNamespace() {
    return '.mousedownOutside' + this.id;
  }

  public render() {

    const testId = this.props.tbTestId || 'menu';

    const menuButtonWrapper = DeprecatedReactMenu.ButtonWrapper.element(
      {
        onClick: () => this.toggleMenu(),
        menuButtonFactory: this.props.menuButtonFactory,
        menuOpen: this.state.open,
        tbTestId: testId + '-button'
      });

    const menuPanelWrapperProps = {
      style: this.props.menuPanelStyle,
      tbTestId: testId + '-panel',
      alignRight: this.props.alignPanelRight
    };

    // this logic should be within the component, not out here
    const menuPanelWrapper = this.state.open
      ? DeprecatedReactMenu.PanelWrapper.element(menuPanelWrapperProps, this.props.menuPanelFactory({ menu: this }))
      : null;

    const menuStyle = _.extend({},
      {
        position: 'relative',
        display: 'inline-block'
      },
      this.props.style
    );

    return React.createElement('span', {
        'data-tb-test-id': testId,
        style: menuStyle,
        onKeyDown: (e: React.KeyboardEvent<HTMLSpanElement>) => this.onKeyDown(e)
      } as React.HTMLAttributes<HTMLSpanElement>,
      menuButtonWrapper,
      menuPanelWrapper
    );

  }

  private onKeyDown(event: React.KeyboardEvent<HTMLSpanElement>) {
    if (event.keyCode === Keys.Escape) {
      this.closeMenu();
      if (this.props.focusOnEscape) {
        // set the focus to the menu button when closing on 'escape'
        $(`span[data-tb-test-id='${this.props.tbTestId + '-button'}'] div[role='button']`).focus();
      }
    }
  }

  private toggleMenu() {
    if (this.isMenuOpen()) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  private isMenuOpen() {
    return this.state.open;
  }

  private openMenu() {
    if (this.props.isDisabled) {
      return;
    } else if (this.props.onBeforeMenuOpen) {
      this.props.onBeforeMenuOpen().then(() => { this._openMenu(); });
    } else {
      this._openMenu();
    }
  }

  private _openMenu() {
    this.setState({open: true});
  }

  public closeMenu() {
    this.setState({ open: false });
  }

}

export module DeprecatedReactMenu {

  export interface Props {
    menuButtonFactory: React.Factory<ButtonProps>;
    menuPanelFactory: React.Factory<any>;
    onBeforeMenuOpen?: () => Q.Promise<any>;
    style?: React.CSSProperties;
    menuPanelStyle?: any;
    tbTestId?: string;
    menuPanelDivId?: string;
    isDisabled?: boolean;
    attachUpdateTriggerToScope?: () => void;
    alignPanelRight?: boolean;
    focusOnEscape?: boolean;
  }

  export interface ButtonProps {
    // TODO: refactor Menu consumers so that these properties don't have to be declared optional.
    hovered?: boolean;
    menuOpen?: boolean;
  }

  export interface PanelProps {
    // TODO: refactor Menu consumers so that this property doesn't have to be declared optional.
    menu?: DeprecatedReactMenu;
  }

  export interface State {
    open?: boolean;
    hovered?: boolean;
  }


  export class ButtonWrapper extends React.Component<ButtonWrapper.Props, ButtonWrapper.State> {

    static displayName = 'MenuButtonWrapper';

    public static element = React.createFactory(ButtonWrapper);

    state: ButtonWrapper.State = {
      hovered: false
    };

    public render() {
      return React.createElement('span',
        {
          onClick: () => this.props.onClick(),
          onKeyDown: (e: React.KeyboardEvent<HTMLSpanElement>) => this.onKeyDown(e),
          onMouseOver: () => this.handleMouseOver(),
          onMouseOut: () => this.handleMouseOut(),
          style: {cursor: 'pointer'},
          'data-tb-test-id': this.props.tbTestId
        } as React.HTMLAttributes<HTMLDivElement>,
        this.props.menuButtonFactory({
          hovered: this.state.hovered,
          menuOpen: this.props.menuOpen
        }));
    }

    private onKeyDown(event: React.KeyboardEvent<HTMLSpanElement>) {
      if (event.keyCode === Keys.Enter || event.keyCode === Keys.Space) {
        this.props.onClick();
      }
    }

    private handleMouseOver() {
      this.setState({ hovered: true });
    }

    private handleMouseOut() {
      this.setState({ hovered: false });
    }

  }

  export module ButtonWrapper {

    export interface Props {
      onClick: () => void;
      menuOpen: boolean;
      menuButtonFactory: React.Factory<DeprecatedReactMenu.ButtonProps>;
      tbTestId?: string;
    }

    export interface State {
      hovered?: boolean;
    }

  }


  export class PanelWrapper extends React.Component<PanelWrapper.Props, PanelWrapper.State> {

    static displayName = 'MenuPanelWrapper';

    public static element = React.createFactory(PanelWrapper);

    public constructor(props: PanelWrapper.Props) {
      super(props);
      this.state = {alignRight: this.props.alignRight};
    }

    public componentDidMount() {
      const node = $(ReactDOM.findDOMNode(this));
      const rightEdge = node.offset().left + node.outerWidth();
      const windowWidth = $(window).width();

      if (rightEdge >= windowWidth) {
        this.setState({ alignRight: true });
      }
    }

    public render() {
      const style = _.extend(
        {
          position: 'absolute',

          left: this.state.alignRight ? null : 0,
          right: this.state.alignRight ? 0 : null,
          // quick hacky fix so that it appears above all card-elements.
          // CardViewStyles::SelectCheckbox has zIndex of 5.
          // The right way to fix it would be to port to shared widgets.
          // Another reason this class is called DeprecatedReactMenu
          zIndex: 6,
          textAlign: 'left'
        },
        this.props.style);

      return React.createElement('div', {
          'data-tb-test-id': this.props.tbTestId,
          style: style
        } as React.HTMLAttributes<HTMLDivElement>,
        this.props.children
      );

    }

  }

  export module PanelWrapper {

    export interface Props {
      style: any;
      alignRight: boolean;
      tbTestId?: string;
    }

    export interface State {
      // alignRight: If true, aligns the menu with the right side of the menu button.
      // This will happen if the menu extends beyond the right edge of the browser viewport.
      alignRight?: boolean;
    }

  }

}
